import "./SettingsPage.scss";
import { useTranslation } from 'react-i18next';
import SettingsPreferrences from "../../components/SettingsPreferrences/SettingsPreferrences";
import { useEffect } from "react";
import { useSettingsPageProvider } from "../../providers/SettingsProvider";

export default function SettingsPage() {
  const { t } = useTranslation();
  const settingsContext = useSettingsPageProvider();

  useEffect(() => {
    settingsContext.getSyncedCalendarData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <div className="setting-page__container">
      <div className='setting-page__header-container'>
        <div className="setting-page__header">
          <h1>{t('settingsScreen.title')}</h1>
        </div>
      </div>
      <SettingsPreferrences />
    </div>
  );
}
